import { render, staticRenderFns } from "./quarantineDetail.vue?vue&type=template&id=7385527f&scoped=true&"
import script from "./quarantineDetail.vue?vue&type=script&lang=js&"
export * from "./quarantineDetail.vue?vue&type=script&lang=js&"
import style0 from "./quarantineDetail.vue?vue&type=style&index=0&id=7385527f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7385527f",
  null
  
)

export default component.exports